import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../../constants/common'
import Button, { BUTTON_HEIGHT_24 } from '../../../../../Button'
import { ListItemIcons } from '../../../../../ListItem'

import DeleteIcon from '../../../../../../icons/delete.svg'

function CopiedToMoreItemIcons({ isHovered, onDelete, ...restProps }) {
  const { t } = useTranslation()

  return (
    <ListItemIcons {...restProps}>
      {isHovered && onDelete ? (
        <Button.Contained
          isLight
          beforeIconProps={{ Icon: DeleteIcon }}
          height={BUTTON_HEIGHT_24}
          tooltip={t('EmailProfile.CopyDeleteButtonTooltipKey')}
          tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
          onClick={onDelete}
        />
      ) : null}
    </ListItemIcons>
  )
}

export default CopiedToMoreItemIcons
